import React from "react";
import { hasAnalyticsChoice, setAnalyticsAllowed, ensureVisitorId, clearVisitorId } from "../lib/consent";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export default function AnalyticsConsentModal() {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setOpen(!hasAnalyticsChoice());
  }, []);

  const enforceOpen = (next) => {
    // Prevent closing until user explicitly chooses Accept or Decline
    if (!hasAnalyticsChoice()) {
      setOpen(true);
    } else {
      setOpen(next);
    }
  };

  const onAccept = () => {
    setAnalyticsAllowed(true);
    ensureVisitorId();
    setOpen(false);
    try { window.dispatchEvent(new CustomEvent("rl_analytics_consent", { detail: { accepted: true, decided: true } })); } catch (_) {}
  };

  const onDecline = () => {
    setAnalyticsAllowed(false);
    clearVisitorId();
    setOpen(false);
    try { window.dispatchEvent(new CustomEvent("rl_analytics_consent", { detail: { accepted: false, decided: true } })); } catch (_) {}
  };

  const preventClose = (e) => {
    // disable overlay click and escape
    e.preventDefault();
  };

  if (!open) return null;

  return (
    <Dialog open={open} onOpenChange={enforceOpen}>
      <DialogContent hideClose onEscapeKeyDown={preventClose} onPointerDownOutside={preventClose} onInteractOutside={preventClose} className="max-w-md" data-testid="analytics-consent-modal">
        <DialogHeader>
          <DialogTitle data-testid="analytics-consent-title">Allow ad + improvement cookies?</DialogTitle>
          <DialogDescription data-testid="analytics-consent-description">
            We use first-party cookies for ad relevance and anonymous usage insights so we can improve the site experience for you.
            No personal identity data is stored. See our{" "}
            <Link to="/privacy" className="underline" data-testid="analytics-consent-privacy-link">Privacy</Link>.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-3 flex items-center justify-end gap-2">
          <button onClick={onDecline} className="px-3 py-1.5 text-sm rounded border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-200" data-testid="analytics-consent-decline-button">Decline</button>
          <button onClick={onAccept} className="px-3 py-1.5 text-sm rounded bg-slate-900 text-white dark:bg-white dark:text-slate-900" data-testid="analytics-consent-accept-button">Accept</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}